import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

VueRouter.prototype.open = function (routeObject) {
  const {href} = this.resolve(routeObject)
  window.open(href, '_blank')
}

VueRouter.prototype.reload = function (routeObject) {
  const {href} = this.resolve(routeObject)
  window.location.href = href;
}

const routes = [
  {
    path: '/',
    name: 'login',
    component: () => import('@/views/login.vue')
  },
  // {
  //   path: '/navBar',
  //   name: 'navBar',
  //   component: () => import('@/components/navBar.vue')
  // },
  {
    path: '/empty',
    name: 'Empty',
    component: () => import('@/components/empty.vue')
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('@/views/syst/dashboard/dashBoard.vue')
  },  
  {
    path: '/dashboardHans',
    name: 'DashboardHans',
    component: () => import('@/views/syst/dashboard/dashBoardDev.vue')
  },    
  {
    path: '/dashboardPartners',
    name: 'DashboardPartners',
    component: () => import('@/views/syst/dashboard/dashBoardDev.vue')
  },      
  {
    path: '/aresGPT',
    name: 'aresGPT',
    component: () => import('@/views/syst/openai/aresGPT.vue')
  },      
  {
    path: '/huov/searchHuov',
    name: 'huov/searchHuov',
    component: () => import('@/views/huov/searchHuov.vue')
  },
  {
    path: '/huov/searchTodo',
    name: 'Todo bookings',
    component: () => import('@/views/huov/searchTodo.vue')
  },
  {
    path: '/huov/searchOptie',
    name: 'huov/searchOptie',
    component: () => import('@/views/huov/searchOptie.vue')
  },
  {
    path: '/huov/searchArrivals',
    name: 'huov/searchArrivals',
    component: () => import('@/views/huov/searchArrivals.vue')
  },
  {
    path: '/huov/searchFeratelArrivals',
    name: 'Feratel Search Arrivals',
    component: () => import('@/views/huov/searchFeratelArrivals.vue')
  },
  {
    path: '/huov/searchFeratelArrivalsComplete',
    name: 'Feratel Search Arrivals Complete',
    component: () => import('@/views/huov/searchFeratelArrivalsComplete.vue')
  },
  {
    path: '/huov/searchGuestReminder',
    name: 'huov/searchGuestReminder',
    component: () => import('@/views/huov/searchGuestReminder.vue')
  },
  {
    path: '/huov/searchNegativeBalance',
    name: 'huov/searchNegativeBalance',
    component: () => import('@/views/huov/searchNegativeBalance.vue')
  },  
  {
    path: '/huov/searchUnderOccupancy',
    name: 'huov/searchUnderOccupancy',
    component: () => import('@/views/huov/searchUnderOccupancy.vue')
  },    
  {
    path: '/huov/nwHuov/:taal_code',
    name: 'huov/nwHuov',
    props: true,
    component: () => import('@/views/huov/nwHuov.vue')
  },
  {
    path: '/huov/onHuov/:huov_encrid',
    name: 'Rentalcontract details',
    props: true,
    component: () => import('@/views/huov/onHuov.vue')
  },
  {
    path: '/huov/ovrz/list1',
    name: 'Rentalcontract overview 1',
    component: () => import('@/views/huov/ovrz/list1.vue')
  },
  {
    path: '/huov/huovPrijsUitleg/:huov_encrid',
    name: 'Rentalcontract price explenation',
    props: true,
    component: () => import('@/views/huov/huovPrijsUitleg.vue')
  },
  {
    path: '/huov/chaturls/:param',
    name: 'Chat urls',
    props: true,
    component: () => import('@/views/huov/chaturls.vue')
  },  
  {
    path: '/huis/searchHuis',
    name: 'Search Accommodation',
    component: () => import('@/views/huis/searchHuis.vue')
  },
  {
    path: '/overviewHuisPhotographer',
    name: 'Accommodation Overview Photographer',
    component: () => import('@/views/huis/overviewHuisPhotographer.vue')
  },
  {
    path: '/overviewHsfoPhotographer',
    name: 'Dashboard Photographer',
    component: () => import('@/views/huis/overviewHsfoPhotographer.vue')
  },
  {
    path: '/huis/onHuis/:huis_encrid',
    name: 'Accommodation details',
    props: true,
    component: () => import('@/views/huis/onHuis.vue')
  },  
  {
    path: '/huis/onHsfoPhotographer/:hsfo_encrid',
    name: 'Accommodation details stripped',
    props: true,
    component: () => import('@/views/huis/onHsfoPhotographer.vue')
  },
  {
    path: '/huis/copyHuis',
    name: 'Copy Accommodation',
    component: () => import('@/views/huis/copyHuis.vue')
  },
  {
    path: '/huis/copyHuis2',
    name: 'Copy Acco items to Acco',
    component: () => import('@/views/huis/copyHuis2.vue')
  },
  {
    path: '/huis/ovrz/hser',
    name: 'Accommodation error overview',
    component: () => import('@/views/huis/ovrz/hser.vue')
  },
  {
    path: '/huis/ovrz/list1',
    name: 'Accommodation overview 1',
    component: () => import('@/views/huis/ovrz/list1.vue')
  },
  {
    path: '/huis/ovrz/actions',
    name: 'Accommodation overview actions',
    component: () => import('@/views/huis/ovrz/actionsList.vue')
  },
  {
    path: '/huis/ovrz/listAudit1',
    name: 'Accommodation Audit 1',
    component: () => import('@/views/huis/ovrz/listAudit1.vue')
  },
  {
    path: '/huis/ovrz/listOccupancy1',
    name: 'Accommodation Occupancy 1',
    component: () => import('@/views/huis/ovrz/listOccupancy1.vue')
  },
  {
    path: '/eign/searchEign',
    name: 'Search Hosts',
    component: () => import('@/views/eign/searchEign.vue')
  },
  {
    path: '/eign/onEign/:eign_encrid',
    name: 'Hosts details',
    props: true,
    component: () => import('@/views/eign/onEign.vue')
  },
  {
    path: '/eign/addEign',
    name: 'Add Host',
    component: () => import('@/views/eign/addEign.vue')
  },
  {
    path: '/eign/addHuis/:eign_encrid',
    name: 'Add Accommodation',
    props: true,
    component: () => import('@/views/eign/addHuis.vue')
  },
  {
    path: '/eign/hefc/mnHefc',
    name: 'Host Invoices',
    props: true,
    component: () => import('@/views/eign/hefc/mnHefc.vue')
  },
  {
    path: '/pten/dashBoardPten',
    name: 'Dashboard Potential Hosts',
    component: () => import('@/views/pten/dashBoardPten.vue')
  },
//   {
//     path: '/pten/dashBoardPtenAgent',
//     name: 'Dashboard Potential Hosts for an agent',
//     component: () => import('@/views/pten/dashBoardPtenAgent.vue')
//   },
  {
    path: '/pten/searchPtenAssign',
    name: 'Assign Potential Hosts',
    component: () => import('@/views/pten/searchPtenAssign.vue')
  },
  {
    path: '/pten/searchPtenDeduplicate',
    name: 'Deduplicate Potential Hosts',
    component: () => import('@/views/pten/searchPtenDeduplicate.vue')
  },
  {
    path: '/pten/searchPtenPhonelist',
    name: 'Telephone list leads',
    component: () => import('@/views/pten/searchPtenPhonelist.vue')
  },
  {
    path: '/pten/searchPten',
    name: 'Search Potential Hosts',
    component: () => import('@/views/pten/searchPten.vue')
  },
  {
    path: '/pten/searchPtenAgents',
    name: 'Search Agents',
    component: () => import('@/views/pten/searchPtenAgents.vue')
  },
  {
    path: '/pten/searchPtenAction/:option',
    name: 'Search All Actions',
    props: true,
    component: () => import('@/views/pten/searchPtenAction.vue')
  },
  {
    path: '/pten/searchPten/:option',
    name: 'Search All Potential Hosts',
    props: true,
    component: () => import('@/views/pten/searchPten.vue')
  },
  {
    path: '/pten/onPten/',
    name: 'Add Potential Host',
    component: () => import('@/views/pten/onPten.vue')
  },
  {
    path: '/pten/onPten/:pten_encrid',
    name: 'Potential Hosts details',
    props: true,
    component: () => import('@/views/pten/onPten.vue')
  },
  {
    path: '/pten/mapPten',
    name: 'Map of Potential Hosts',
    component: () => import('@/views/pten/mapPten.vue')
  },
  {
    path: '/eign/hefc/searchHefcTmp',
    name: 'Host Temporary Invoices search',
    component: () => import('@/views/eign/hefc/searchHefcTmp.vue')
  },
  {
    path: '/eign/hefc/searchHefc',
    name: 'Host Invoices search',
    component: () => import('@/views/eign/hefc/searchHefc.vue')
  },
  {
    path: '/eign/hefc/searchHefcExact',
    name: 'Host Invoices to Exact',
    component: () => import('@/views/eign/hefc/searchHefcExact.vue')
  },
  {
    path: '/eign/hefc/onHefcTmp/:hefc_encrid',
    name: 'Host Proforma Invoice details',
    props: true,
    component: () => import('@/views/eign/hefc/onHefcTmp.vue')
  },
  {
    path: '/eign/hefc/onHefc/:hefc_encrid',
    name: 'Host Invoice details',
    props: true,
    component: () => import('@/views/eign/hefc/onHefc.vue')
  },
  {
    path: '/eign/hefc/salesFact',
    name: 'Montly sales invoices',
    component: () => import('@/views/eign/hefc/salesFact.vue')
  },
  {
    path: '/eign/hefc/guaranteeFact',
    name: 'Montly guarantee invoices',
    component: () => import('@/views/eign/hefc/guaranteeFact.vue')
  },
  {
    path: '/eign/ovrz/list1',
    name: 'Host overview 1',
    component: () => import('@/views/eign/ovrz/list1.vue')
  },
  {
    path: '/huis/hsva/showHsva/:huis_encrid',
    name: 'Acco Q and A',
    props: true,
    component: () => import('@/views/huis/hsva/showHsva.vue')
  },
  {
    path: '/huis/hspt/hsnp/updHsnp/:hspt_encrid',
    name: 'Night prices',
    props: true,
    component: () => import('@/views/huis/hspt/hsnp/updHsnp.vue')
  },
  {
    path: '/huis/hspt/hsnp/updmHsnp/:hspt_encrid',
    name: 'Update multiple night prices',
    props: true,
    component: () => import('@/views/huis/hspt/hsnp/updmHsnp.vue')
  },  
  {
    path: '/huis/hspt/hsfp/updHsfp/:hspt_encrid',
    name: 'LOSprices',
    props: true,
    component: () => import('@/views/huis/hspt/hsfp/updHsfp.vue')
  },
  {
    path: '/huis/hspt/restorePriceBackup/:hspt_encrid',
    name: 'Restore pricesfrom backup',
    props: true,
    component: () => import('@/views/huis/hspt/restorePriceBackup.vue')
  },  
  {
    path: '/huis/hsii/updHsii/:huis_encrid/:hsiiDisplay',
    name: 'Layout',
    props: true,
    component: () => import('@/views/huis/hsii/updHsii.vue')
  },
  {
    path: '/huis/hsii/hsiiOverview/:huis_encrid',
    name: 'Layout new',
    props: true,
    component: () => import('@/views/huis/hsii/hsiiOverview.vue')
  },
  {
    path: '/klnt/searchKlnt',
    name: 'Search Guest',
    component: () => import('@/views/klnt/searchKlnt.vue')
  },
  {
    path: '/klnt/onKlnt/:klnt_encrid',
    name: 'Guest details',
    props: true,
    component: () => import('@/views/klnt/onKlnt.vue')
  },
  {
    path: '/hpbz/searchHpbz',
    name: 'Search Host booking old',
    component: () => import('@/views/hpbz/searchHpbz.vue')
  },
  {
    path: '/hpbz/onhpbz/:hpbz_encrid/:huis_encrid',
    name: 'Host booking details old',
    props: true,
    component: () => import('@/views/hpbz/onHpbz.vue')
  },
  {
    path: '/heho/searchHeho',
    name: 'Search Host booking',
    component: () => import('@/views/heho/searchHeho.vue')
  },
  {
    path: '/heho/ovrz/list1',
    name: 'Host booking overview 1',
    component: () => import('@/views/heho/ovrz/list1.vue')
  },
  {
    path: '/heho/searchHostRequests',
    name: 'Search Host booking requests',
    component: () => import('@/views/heho/searchHostRequests.vue')
  },
  {
    path: '/heho/onheho/:heho_encrid/:huis_encrid',
    name: 'Host booking details',
    props: true,
    component: () => import('@/views/heho/onHeho.vue')
  },
  {
    path: '/syst/jsonrpc-intern/mnJrpc',
    name: 'JSON-RPC VFY',
    props: true,
    component: () => import('@/views/syst/jsonrpc-intern/mnJrpc.vue')
  },
  {
    path: '/syst/ref/wseo/searchWseo',
    name: 'SEO content VfY website',
    props: true,
    component: () => import('@/views/syst/ref/wseo/searchWseo.vue')
  },
  {
    path: '/syst/misc/myBookingUrls',
    name: 'MyBooking URLS',
    props: true,
    component: () => import('@/views/syst/misc/myBookingUrls.vue')
  },
  {
    path: '/syst/misc/myBookingEncrid',
    name: 'MyBooking Encrid',
    props: true,
    component: () => import('@/views/syst/misc/myBookingEncrid.vue')
  },  
  {
    path: '/syst/misc/myBookingStats',
    name: 'MyBooking Stats',
    props: true,
    component: () => import('@/views/syst/misc/myBookingStats.vue')
  },    
  {
    path: '/syst/misc/myVillaStats',
    name: 'MyVilla Stats',
    props: true,
    component: () => import('@/views/syst/misc/myVillaStats.vue')
  },    
  {
    path: '/syst/misc/aresstats',
    name: 'Ares Stats',
    props: true,
    component: () => import('@/views/syst/misc/aresstats.vue')
  },    
  {
    path: '/syst/ref/prov/searchProv',
    name: 'Website regions',
    props: true,
    component: () => import('@/views/syst/ref/prov/searchProv.vue')
  },
  {
    path: '/syst/ref/hgrp/searchHgrp',
    name: 'Website regions parks',
    props: true,
    component: () => import('@/views/syst/ref/hgrp/searchHgrp.vue')
  },  
  {
    path: '/syst/ref/skrg/searchSkrg/:regi_type',
    name: 'Website regions ski-areas',
    props: true,
    component: () => import('@/views/syst/ref/skrg/searchSkrg.vue')
  },    
  {
    path: '/syst/ref/skrg/overviewSkrg',
    name: 'Website regions ski-areas overview',
    props: true,
    component: () => import('@/views/syst/ref/skrg/overviewSkrg.vue')
  },    
  {
    path: '/syst/ref/mnRef',
    name: 'Reference data',
    props: true,
    component: () => import('@/views/syst/ref/mnRef.vue')
  },
// Verwijderd - nu geen skiliften meer, alleen regio's
//   {
//     path: '/syst/ref/sklf/sklf',
//     name: 'Skilift overview',
//     component: () => import('@/views/syst/ref/sklf/sklf.vue')
//   },
  {
    path: '/task/fin/mnFin',
    name: 'Finance',
    props: true,
    component: () => import('@/views/task/fin/mnFin.vue')
  },
  {
    path: '/task/fin/exact/excelExportEign',
    name: 'Excel Export Hosts',
    component: () => import('@/views/task/fin/exact/excelExportEign.vue')
  },
  {
    path: '/task/fin/exact/excelExportGbmt4',
    name: 'Excel Export excelExportGbmt4',
    component: () => import('@/views/task/fin/exact/excelExportGbmt4.vue')
  },  
  {
    path: '/task/fin/exact/excelExportInpt',
    name: 'Excel Export Sales partners',
    component: () => import('@/views/task/fin/exact/excelExportInpt.vue')
  },
  {
    path: '/task/fin/exact/afsluit',
    name: 'Close ledger mutation period',
    component: () => import('@/views/task/fin/exact/afsluit.vue')
  },
  {
    path: '/task/fin/ovrz/excelExportGbmt1',
    name: 'Excel Export Financial muations',
    component: () => import('@/views/task/fin/ovrz/excelExportGbmt1.vue')
  },
  {
    path: '/task/fin/ovrz/excelExportGbmt2',
    name: 'Excel Export Financial overview',
    component: () => import('@/views/task/fin/ovrz/excelExportGbmt2.vue')
  },
  {
    path: '/task/fin/ovrz/excelExportGbmt3',
    name: 'Excel Export Ledger accountoverview',
    component: () => import('@/views/task/fin/ovrz/excelExportGbmt3.vue')
  },
  {
    path: '/task/fin/ovrz/excelExportSchadeVerz',
    name: 'Excel Export Damage insurance',
    component: () => import('@/views/task/fin/ovrz/excelExportSchadeVerz.vue')
  },
  {
    path: '/task/fin/ovrz/excelExportAgentComControle',
    name: 'Excel Export Agent commission check',
    component: () => import('@/views/task/fin/ovrz/excelExportAgentComControle.vue')
  },
  {
    path: '/task/fin/ovrz/excelExportAgentCom',
    name: 'Excel Export Agent commission',
    component: () => import('@/views/task/fin/ovrz/excelExportAgentCom.vue')
  },
  {
    path: '/task/fin/ovrz/excelExportKltg',
    name: 'Excel Export Guest Credits',
    component: () => import('@/views/task/fin/ovrz/excelExportKltg.vue')
  },
  {
    path: '/task/fin/ovrz/excelExportKlpt',
    name: 'Excel Export Guest Points',
    component: () => import('@/views/task/fin/ovrz/excelExportKlpt.vue')
  },
  {
    path: '/task/fin/ovrz/excelExportHoct',
    name: 'Excel Export Booking - Host',
    component: () => import('@/views/task/fin/ovrz/excelExportHoct.vue')
  },
  {
    path: '/task/fin/ovrz/tableAgentComm',
    name: 'Agent commission overview',
    component: () => import('@/views/task/fin/ovrz/tableAgentComm.vue')
  },
  {
    path: '/task/fin/ovrz/excelExportPubl',
    name: 'Excel Export Publication contribution',
    component: () => import('@/views/task/fin/ovrz/excelExportPubl.vue')
  },
  {
    path: '/task/fin/abn/bkmt/searchBkmt1',
    name: 'Recent mutations',
    component: () => import('@/views/task/fin/abn/bkmt/searchBkmt1.vue')
  },
  {
    path: '/task/fin/abn/settlingHosts',
    name: 'Settling Hosts',
    component: () => import('@/views/task/fin/abn/settlingHosts.vue')
  },
  {
    path: '/task/fin/abn/searchBtodNew',
    name: 'Payment orders New',
    component: () => import('@/views/task/fin/abn/searchBtodNew.vue')
  },
  {
    path: '/task/fin/abn/searchBtodExported/',
    name: 'Payment orders Exported',
    component: () => import('@/views/task/fin/abn/searchBtodExported.vue')
  },
  {
    path: '/task/fin/abn/searchBtodDone/',
    name: 'Payment orders Done',
    component: () => import('@/views/task/fin/abn/searchBtodDone.vue')
  },
  {
    path: '/task/fin/abn/searchNotInAres/',
    name: 'Mutation not in ABN',
    component: () => import('@/views/task/fin/abn/searchNotInAres.vue')
  },
  {
    path: '/task/fin/paynl/clearings/',
    name: 'Clearings',
    component: () => import('@/views/task/fin/paynl/clearings.vue')
  },  
  {
    path: '/task/fin/paynl/paid/',
    name: 'Paid',
    component: () => import('@/views/task/fin/paynl/hobo_paid.vue')
  },    
  /*
  {
    path: '/task/hogr/mnHogr',
    name: 'Guest reviews',
    component: () => import('@/views/task/hogr/mnHogr.vue')
  },
  {
    path: '/task/hogr/searchHogr',
    name: 'Search Guest reviews',
    component: () => import('@/views/task/hogr/searchHogr.vue')
  },
  {
    path: '/task/hogr/onHogr/:hogr_encrid',
    name: 'Guest Review',
    props: true,
    component: () => import('@/views/task/hogr/onHogr.vue')
  },
  */
  {
    path: '/task/agent/mnAgent',
    name: 'Agents menu',
    props: true,
    component: () => import('@/views/task/agent/mnAgent.vue')
  }, 
  {
    path: '/task/agent/ovrz/scale',
    name: 'Commission scale',
    props: true,
    component: () => import('@/views/task/agent/ovrz/scale.vue')
  }, 
  {
    path: '/task/agent/ovrz/searchAgentScale/:encrid',
    name: 'Commission scale overview',
    props: true,
    component: () => import('@/views/task/agent/ovrz/searchAgentScale.vue')
  }, 
  {
    path: '/task/guestMessages/mnGuestMessages',
    name: 'Guest messages',
    props: true,
    component: () => import('@/views/task/guestMessages/mnGuestMessages.vue')
  },
  {
    path: '/task/guestMessages/bcms/getBcmsAll',
    name: 'Booking.com all messages',
    component: () => import('@/views/task/guestMessages/bcms/getBcmsAll.vue')
  },
  {
    path: '/task/guestMessages/bcms/onBcms/:bcms_encrid',
    name: 'Booking.com messages details',
    props: true,
    component: () => import('@/views/task/guestMessages/bcms/onBcms.vue')
  },
  {
    path: '/task/guestMessages/smsr/getSmsrAll',
    name: 'SMS receivedmessages',
    component: () => import('@/views/task/guestMessages/smsr/getSmsrAll.vue')
  },
  {
    path: '/task/guestMessages/smsr/onSmsr/:smsr_encrid',
    name: 'SMS messages details',
    props: true,
    component: () => import('@/views/task/guestMessages/smsr/onSmsr.vue')
  },
  {
    path: '/task/excel/mnExcel',
    name: 'General Excel exports',
    props: true,
    component: () => import('@/views/task/excel/mnExcel.vue')
  },
   
  {
    path: '/task/customer_success/mnCustomerSuccess',
    name: 'Customer success',
    props: true,
    component: () => import('@/views/task/customer_success/mnCustomerSuccess.vue')
  },  
  {
    path: '/task/customer_success/hosm/hosm_overview/:param',
    name: 'Damage claims overview',
    props:true,
    component: () => import('@/views/task/customer_success/hosm/hosm_overview.vue')
  },
  {
    path: '/task/customer_success/hokl/hokl_overview/:param',
    name: 'Complaints claims overview',
    props:true,
    component: () => import('@/views/task/customer_success/hokl/hokl_overview.vue')
  }, 
  {
    path: '/task/customer_success/homb/homb_overview/:param',
    name: 'Rebooking overview',
    props:true,
    component: () => import('@/views/task/customer_success/homb/homb_overview.vue')
  }, 
  {
    path: '/task/customer_success/howz/howz_overview/:param',
    name: 'Change overview',
    props:true,
    component: () => import('@/views/task/customer_success/howz/howz_overview.vue')
  }, 
  {
    path: '/task/customer_success/openai/prompts/:fromPage',
    name: 'Prompts overview',
    props:true,
    component: () => import('@/views/task/customer_success/openai/prompts.vue')
  },
  {
    path: '/task/customer_success/openai/questions',
    name: 'Questions overview',
    props:false,
    component: () => import('@/views/task/customer_success/openai/questions.vue')
  },
  {
    path: '/task/customer_success/openai/std_questions',
    name: 'Standaard questions overview',
    props:false,
    component: () => import('@/views/task/customer_success/openai/std_questions.vue')
  },
  {
    path: '/task/customer_success/openai/std_questions/:oavr_nr',
    name: 'Standaard questions overview from pending',
    props: true,
    component: () => import('@/views/task/customer_success/openai/std_questions.vue')
  },
  {
    path: '/task/customer_success/openai/user_questions',
    name: 'User questions overview',
    props:false,
    component: () => import('@/views/task/customer_success/openai/user_questions.vue')
  },
  {
    path: '/wzvz/wzvz_cs_overview',
    name: 'CS Host pending changes',
    props:false,
    component: () => import('@/views/wzvz/wzvz_cs_overview.vue')
  },
  {
    path: '/wzvz/wzvz_cs_overview/:filter',
    name: 'CS Host pending changes filtered',
    props:true,
    component: () => import('@/views/wzvz/wzvz_cs_overview.vue')
  },
  {
    path: '/wzvz/wzvz_cs_overview/:filter/:acco',
    name: 'CS Host pending changes filtered on accommodation',
    props:true,
    component: () => import('@/views/wzvz/wzvz_cs_overview.vue')
  },
  {
    path: '/wzvz/wzvz_cs_overview_all/:filter',
    name: 'CS Host all changes',
    props:true,
    component: () => import('@/views/wzvz/wzvz_cs_overview_all.vue')
  },
  {
    path: '/task/customer_success/revw/onReview2/:param',
    name: 'Review details',
    props: true,
    component: () => import('@/views/task/customer_success/revw/onReview2.vue')
  },  
  {
    path: '/task/customer_success/host/ovrz/ovrz1',
    name: 'Reviews per role overview',
    // props:true,
    component: () => import('@/views/task/customer_success/host/ovrz/ovrz1.vue')
  },   
  {
    path: '/task/customer_success/huov/ovrz/ovrz1',
    name: 'Cancellation Insurance Report',
    // props:true,
    component: () => import('@/views/task/customer_success/huov/ovrz/ovrz1.vue')
  },     
  {
    path: '/huov/hokl/sendHokl/:param',
    name: 'Send complaint',
    props:true,
    component: () => import('@/views/huov/hokl/sendHokl.vue')
  },    
  {
    path: '/huov/hosm/sendHosm/:param',
    name: 'Send damage claim',
    props:true,
    component: () => import('@/views/huov/hosm/sendHosm.vue')
  },      
  {
    path: '/task/customer_success/revw/revw_overview3/:param',
    name: 'Reviews overview',
    props:true,
    component: () => import('@/views/task/customer_success/revw/revw_overview3.vue')
  },    
  {
    path: '/task/customer_success/revw/onReview/:param',
    name: 'Guest Review',
    props: true,
    component: () => import('@/views/task/customer_success/revw/onReview.vue')
  },  
  {
    path: '/task/customer_success/bdiag/prognosis',
    name: 'Booking prognosis',
    component: () => import('@/views/task/customer_success/bdiag/prognosis.vue')
  },    
  {
    path: '/task/customer_success/bdiag/diagnose',
    name: 'Booking preview',
    component: () => import('@/views/task/customer_success/bdiag/diagnose.vue')
  },    
  {
    path: '/task/excel/tmp/chantal',
    name: 'Excel tmp Chantal',
    component: () => import('@/views/task/excel/tmp/chantal.vue')
  },
  {
    path: '/task/excel/tmp/chantal3',
    name: 'Excel tmp Chantal (3)',
    component: () => import('@/views/task/excel/tmp/chantal3.vue')
  },  
  {
    path: '/task/excel/tmp/chantal4',
    name: 'Excel tmp Chantal (4)',
    component: () => import('@/views/task/excel/tmp/chantal4.vue')
  },    
  {
    path: '/task/excel/tmp/emma',
    name: 'Excel tmp Emma (1)',
    component: () => import('@/views/task/excel/tmp/emma.vue')
  },    
  {
    path: '/task/excel/tmp/sanne',
    name: 'Excel tmp sanne',
    component: () => import('@/views/task/excel/tmp/sanne.vue')
  },
  {
    path: '/task/marketing/ovrz/winaction',
    name: 'Win Action Applicants',
    component: () => import('@/views/task/marketing/ovrz/winaction.vue')
  },  
  {
    path: '/task/marketing/propertybrochure',
    name: 'Property Brochure Applicants',
    component: () => import('@/views/task/marketing/propertybrochure.vue')
  },    
  {
    path: '/task/excel/tmp/deploytec',
    name: 'Excel tmp deploytec',
    component: () => import('@/views/task/excel/tmp/deploytec.vue')
  },
  {
    path: '/task/excel/tmp/sybrand',
    name: 'Excel tmp Sybrand',
    component: () => import('@/views/task/excel/tmp/sybrand.vue')
  },
  {
    path: '/task/excel/tmp/petra',
    name: 'Excel tmp Petra',
    component: () => import('@/views/task/excel/tmp/petra.vue')
  },
  {
    path: '/task/various/mnVarious',
    name: 'Various',
    props: true,
    component: () => import('@/views/task/various/mnVarious.vue')
  },
  {
    path: '/task/marketing/mnMarketing',
    name: 'Marketing',
    props: true,
    component: () => import('@/views/task/marketing/mnMarketing.vue')
  },  
  {
    path: '/task/inpt/mnInpt',
    name: 'Sales partners',
    props: true,
    component: () => import('@/views/task/inpt/mnInpt.vue')
  },
  {
    path: '/task/inpt/airbnb/impAipo',
    name: 'Airbnb payout import CSV',
    component: () => import('@/views/task/inpt/airbnb/impAipo.vue')
  },
  {
    path: '/task/inpt/airbnb/searchHuovAirbnbOpen',
    name: 'huov/searchHuovAirbnbOpen',
    component: () => import('@/views/task/inpt/airbnb/searchHuovAirbnbOpen.vue')
  },
  {
    path: '/task/inpt/airbnb/searchHuovAirbnbPaymentDiff',
    name: 'huov/searchHuovAirbnbPaymentDiff',
    component: () => import('@/views/task/inpt/airbnb/searchHuovAirbnbPaymentDiff.vue')
  },
  {
    path: '/task/inpt/airbnb/searchAirbnbAipoHspr',
    name: 'searchAirbnbAipoHspr',
    component: () => import('@/views/task/inpt/airbnb/searchAirbnbAipoHspr.vue')
  },
  {
    path: '/task/inpt/airbnb/searchAirbnbAlterations',
    name: 'searchAirbnbAlterations',
    component: () => import('@/views/task/inpt/airbnb/searchAirbnbAlterations.vue')
  },
  {
    path: '/task/inpt/airbnb/searchAirbnbAres',
    name: 'searchAirbnbAres',
    component: () => import('@/views/task/inpt/airbnb/searchAirbnbAres.vue')
  },
  {
    path: '/task/inpt/airbnb/excelAresAirbnb1',
    name: 'Excel Export Ares vs Airbnb',
    component: () => import('@/views/task/inpt/airbnb/excelAresAirbnb1.vue')
  },
  {
    path: '/task/inpt/airbnb/searchAirbnbAipoBkmt',
    name: 'searchAirbnbAipoBkmt',
    component: () => import('@/views/task/inpt/airbnb/searchAirbnbAipoBkmt.vue')
  },
  {
    path: '/task/inpt/bookingcom/search1',
    name: 'search1',
    component: () => import('@/views/task/inpt/bookingcom/search1.vue')
  },
  {
    path: '/task/inpt/ovrz/ovrz1',
    name: 'Booking excel export 1',
    component: () => import('@/views/task/inpt/ovrz/ovrz1.vue')
  },
  {
    path: '/task/inpt/ovrz/ovrz2',
    name: 'Booking excel export 2',
    component: () => import('@/views/task/inpt/ovrz/ovrz2.vue')
  },  
  {
    path: '/task/inpt/ovrz/ovrz3',
    name: 'Booking excel export 3',
    component: () => import('@/views/task/inpt/ovrz/ovrz3.vue')
  },    
  {
    path: '/task/inpt/ovrz/ovrz4',
    name: 'Sentence 165 export 4',
    component: () => import('@/views/task/inpt/ovrz/ovrz4.vue')
  },    
  {
    path: '/task/inpt/ovrz/ovrz5',
    name: 'Accolist from reference D-date 5',
    component: () => import('@/views/task/inpt/ovrz/ovrz5.vue')
  },   
  {
    path: '/task/inpt/ovrz/ovrz6',
    name: 'unlisted accommodations',
    component: () => import('@/views/task/inpt/ovrz/ovrz6.vue')
  },
  {
    path: '/task/inpt/ovrz/ovrz7',
    name: 'Feratel booking excel export',
    component: () => import('@/views/task/inpt/ovrz/ovrz7.vue')
  },     
  {
    path: '/task/inpt/ovrz/ovrz8',
    name: 'Overview new listing promotions',
    component: () => import('@/views/task/inpt/ovrz/ovrz8.vue')
  },
  {
    path: '/task/inpt/searchInpt',
    name: 'Search Sales Partners',
    component: () => import('@/views/task/inpt/searchInpt.vue')
  },
  {
    path: '/task/inpt/addInpt',
    name: 'Add a Sales Partners',
    component: () => import('@/views/task/inpt/addInpt.vue')
  },
  {
    path: '/task/inpt/onInpt/:inpt_encrid',
    name: 'Sales partner details',
    props: true,
    component: () => import('@/views/task/inpt/onInpt.vue')
  },
  // {
  //   path: '/task/inpt/ipfc/crIpfc1',
  //   name: 'Create monthly sales partner invoices 1',
  //   component: () => import('@/views/task/inpt/ipfc/crIpfc1.vue')
  // },
  {
    path: '/task/inpt/ipfc/crIpfc2',
    name: 'Create monthly sales partner invoices 2',
    component: () => import('@/views/task/inpt/ipfc/crIpfc2.vue')
  },
  {
    path: '/task/inpt/ipfc/searchIpfcTmp',
    name: 'Sales partner Temporary Invoices search',
    component: () => import('@/views/task/inpt/ipfc/searchIpfcTmp.vue')
  },
  {
    path: '/task/inpt/ipfc/searchIpfc',
    name: 'Sales partner Invoices search',
    component: () => import('@/views/task/inpt/ipfc/searchIpfc.vue')
  },
  {
    path: '/task/inpt/ipfc/onIpfcTmp/:ipfc_encrid',
    name: 'Sales partner Proforma Invoice details',
    props: true,
    component: () => import('@/views/task/inpt/ipfc/onIpfcTmp.vue')
  },
  {
    path: '/task/inpt/ipfc/onIpfc/:ipfc_encrid',
    name: 'Sales partner Invoice details',
    props: true,
    component: () => import('@/views/task/inpt/ipfc/onIpfc.vue')
  },
  {
    path: '/task/inpt/ipfc/searchIpfcExact',
    name: 'Sales partner Invoices to Exact',
    component: () => import('@/views/task/inpt/ipfc/searchIpfcExact.vue')
  },
  {
    path: '/syst/gebr/mnGebr',
    name: 'GebrMenu',
    props: true,
    component: () => import('@/views/syst/gebr/mnGebr.vue') // lazyload this component
  },  
  {
    path: '/syst/gebr/authorization/searchTaak',
    name: 'Task Maintenance',
    component: () => import('@/views/syst/gebr/authorization/searchTaak.vue')
  },
  {
    path: '/syst/gebr/authorization/searchGebr',
    name: 'User Maintenance',
    component: () => import('@/views/syst/gebr/authorization/searchGebr.vue')
  }, 
  {
    path: '/syst/gebr/authorization/searchUser',
    name: 'User Task Maintenance',
    component: () => import('@/views/syst/gebr/authorization/searchUser.vue')
  }, 
  {
    path: '/syst/gebr/authorization/taakOverview',
    name: 'Task Overview',
    component: () => import('@/views/syst/gebr/authorization/taakOverview.vue')
  }, 
  {
    path: '/syst/gebr/photographer/searchPhotographer',
    name: 'View Photographers',
    component: () => import('@/views/syst/gebr/photographer/searchPhotographer.vue')
  },
  { // lazyloaded, no props 
    path: '/syst/gebr/myaccount',
    name: 'myaccount',
    component: () => import('@/views/syst/gebr/myaccount/myAccount.vue')
  },  
  { // lazyloaded, no props 
    path: '/syst/gebr/updPassword',
    name: 'updPassword',
    component: () => import('@/views/syst/gebr/updPassword.vue')
  },  
  {
    path: '/misc/passwordReset/:link_encrid',
    name: 'Password reset',
    props: true,
    component: () => import('@/views/misc/passwordReset.vue')
  },    
  {
    path: '/syst/gebr/timeregistration/Registration',
    name: 'Time Registration',
    component: () => import('@/views/syst/gebr/timeregistration/Registration.vue')
  },  
  {
    path: '/misc/bookingApprove/:param',
    name: 'Homeowner booking approve',
    props: true,
    component: () => import('@/views/misc/bookingApprove.vue')
  },    
  {
    path: '/misc/hostCalculation',
    name: 'host calculation info',
    component: () => import('@/views/misc/hostCalculation.vue')
  },  
  {
    path: '/task/pp/mnPp',
    name: 'PurchasePartnerMenu',
    props: true,
    component: () => import('@/views/task/pp/mnPp.vue') // lazyload this component
  },  
  { // lazyloaded, no props 
    path: '/task/pp/ovrz/ovrz1',
    name: 'ExpAddCostQenner',
    component: () => import('@/views/task/pp/ovrz/ovrz1.vue')
  },
  { // lazyloaded, no props 
    path: '/task/pp/ovrz/ovrz2',
    name: 'CheckQennerMapping',
    component: () => import('@/views/task/pp/ovrz/ovrz2.vue')
  },  
  { // lazyloaded, no props 
    path: '/task/pp/ovrz/ovrz3',
    name: 'CheckQennerBookings',
    component: () => import('@/views/task/pp/ovrz/ovrz3.vue')
  },
  { // lazyloaded, no props 
    path: '/task/pp/parcs',
    name: 'ParcsOverview',
    component: () => import('@/views/task/pp/parcs.vue')
  },
  { // lazyloaded, no props 
    path: '/task/pp/mapping',
    name: 'MappingMaintenance',
    component: () => import('@/views/task/pp/mapping.vue')
  },    
  { // lazyloaded, + props 
    path: '/task/pp/accommodations/:filter',
    name: 'AccommodationsOverview',
    props: true,
    component: () => import('@/views/task/pp/accommodations.vue')   
  },      
  {
    path: '/task/various/klnt/mergeKlntList',
    name: 'Merge guest list',
    component: () => import('@/views/task/various/klnt/mergeKlntList.vue')
  },
  {
    path: '/task/various/huov/overviewFeratel',
    name: 'Feratel Overview',
    component: () => import('@/views/task/various/huov/overviewFeratel.vue')
  },
  {
    path: '/task/various/huis/overviewFeratelHuis',
    name: 'Feratel Acco Overview',
    component: () => import('@/views/task/various/huis/overviewFeratelHuis.vue')
  },
  {
    path: '/task/various/huis/overviewFeratelHuis2',
    name: 'Feratel Acco Overview 2',
    component: () => import('@/views/task/various/huis/overviewFeratelHuis2.vue')
  },  
  {
    path: '/task/various/hsfo/overviewHsfo',
    name: 'overview Photo Assignments',
    component: () => import('@/views/task/various/hsfo/overviewHsfo.vue')
  },
  {
    path: '/syst/mltp/mnMltp',
    name: 'Mail templates',
    props: true,
    component: () => import('@/views/syst/mltp/mnMltp.vue')
  },
  // {
  //   path: '/syst/mltp/mainMltp',
  //   name: 'Mail templates main',
  //   props: true,
  //   component: () => import('@/views/syst/mltp/mainMltp.vue')
  // },
  // {
  //   path: '/syst/mltp/searchMltp2/:mltp_doelgroep',
  //   name: 'Search Mail 2',
  //   props: true,
  //   component: () => import('@/views/syst/mltp/searchMltp2.vue')
  // },
  // {
  //   path: '/syst/mltp/mlhf',
  //   name: 'Search Mail header - footer',
  //   component: () => import('@/views/syst/mltp/searchMlhf.vue')
  // },
  {
    path: '/syst/mltp/searchMlhf2',
    name: 'Search Mail header - footer 2',
    component: () => import('@/views/syst/mltp/searchMlhf2.vue')
  },
  // {
  //   path: '/syst/mltp/onMlhf/:mlhf_encrid',
  //   name: 'Mail header - footer',
  //   props: true,
  //   component: () => import('@/views/syst/mltp/onMlhf.vue')
  // },
  {
    path: '/syst/mltp/onMlhf2/:mlhf_encrid',
    name: 'Mail header - footer 2',
    props: true,
    component: () => import('@/views/syst/mltp/onMlhf2.vue')
  },
  {
    path: '/syst/mltp/searchMltp/:mltp_doelgroep',
    name: 'Search Mail',
    props: true,
    component: () => import('@/views/syst/mltp/searchMltp.vue')
  },
  {
    path: '/syst/mltp/onMltp/:mltp_encrid',
    name: 'Mail maintanance',
    props: true,
    component: () => import('@/views/syst/mltp/onMltp.vue')
  },
  {
    path: '/syst/mltp/onMltt/:mltt_encrid',
    name: 'Mail text maintanance',
    props: true,
    component: () => import('@/views/syst/mltp/onMltt.vue')
  },
  {
    path: '/syst/prip/searchPrip',
    name: 'Search price improvement',
    props: true,
    component: () => import('@/views/syst/prip/searchPrip.vue')
  },
  {
    path: '/syst/prip/searchPripTaal/:prip_nr',
    name: 'Priptext maintenance',
    props: true,
    component: () => import('@/views/syst/prip/searchPripTaal.vue')
  },
  {
    path: '/syst/watp/searchWatp/:watp_doelgroep',
    name: 'Search Whatsapp template',
    props: true,
    component: () => import('@/views/syst/watp/searchWatp.vue')
  },  
     
  {
    path: '/syst/watp/onWatp/:watp_encrid',
    name: 'Whatsapp template maintanance',
    props: true,
    component: () => import('@/views/syst/watp/onWatp.vue')
  },  
  {
    path: '/syst/ref/vtwd/searchVtwd',
    name: 'Search translation words',
    component: () => import('@/views/syst/ref/vtwd/searchVtwd.vue')
  },
  {
    path: '/syst/ref/vtwd/onVtwd/:vtwd_encrid',
    name: 'Translation words maintanance',
    props: true,
    component: () => import('@/views/syst/ref/vtwd/onVtwd.vue')
  },
  {
    path: '/syst/ref/vttk/searchVttk',
    name: 'Search translation sentences',
    component: () => import('@/views/syst/ref/vttk/searchVttk.vue')
  },
  {
    path: '/syst/ref/vttk/onVttk/:vttk_encrid',
    name: 'Sentence translation maintanance',
    props: true,
    component: () => import('@/views/syst/ref/vttk/onVttk.vue')
  },
  {
    path: '/syst/ref/fcti/searchFcti',
    name: 'Search Invoice line items',
    component: () => import('@/views/syst/ref/fcti/searchFcti.vue')
  },
  {
    path: '/syst/ref/fcti/onFcti/:fcti_encrid',
    name: 'Invoice line items maintanance',
    props: true,
    component: () => import('@/views/syst/ref/fcti/onFcti.vue')
  },
  {
    path: '/syst/ref/gbrk/searchGbrk',
    name: 'Ledger accouns',
    component: () => import('@/views/syst/ref/gbrk/searchGbrk.vue')
  },
  {
    path: '/syst/ref/nttp/searchNttp',
    name: 'Search Notification types',
    component: () => import('@/views/syst/ref/nttp/searchNttp.vue')
  },
    {
    path: '/syst/ref/hust/searchHust',
    name: 'Booking statuses',
    component: () => import('@/views/syst/ref/hust/searchHust.vue')
  },
  {
    path: '/syst/ref/nttp/onNttp/:nttp_encrid',
    name: 'Notification type maintanance',
    props: true,
    component: () => import('@/views/syst/ref/nttp/onNttp.vue')
  },
  {
    path: '/syst/ref/hust/onHust/:hust_encrid',
    name: 'Booking status maintanance',
    props: true,
    component: () => import('@/views/syst/ref/hust/onHust.vue')
  },  
  {
    path: '/syst/ref/hanr/searchHanr',
    name: 'Search Booking cancellation reasons',
    component: () => import('@/views/syst/ref/hanr/searchHanr.vue')
  },
  {
    path: '/syst/ref/hanr/onHanr/:hanr_encrid',
    name: 'Booking cancellation reason maintanance',
    props: true,
    component: () => import('@/views/syst/ref/hanr/onHanr.vue')
  },
  {
    path: '/syst/ref/kstp/searchKstp',
    name: 'Search Additional costs',
    component: () => import('@/views/syst/ref/kstp/searchKstp.vue')
  },
  {
    path: '/syst/ref/kstp/onKstp/:kstp_encrid',
    name: 'Additional costs maintanance',
    props: true,
    component: () => import('@/views/syst/ref/kstp/onKstp.vue')
  },
  {
    path: '/syst/ref/zinn/searchZinn',
    name: 'Search Accommodation sentences',
    component: () => import('@/views/syst/ref/zinn/searchZinn.vue')
  },
  {
    path: '/syst/ref/zinn/onZinn/:zinn_encrid',
    name: 'Accommodation sentences maintanance',
    props: true,
    component: () => import('@/views/syst/ref/zinn/onZinn.vue')
  },
  {
    path: '/syst/ref/idit/searchIdit',
    name: 'Search Layout item types',
    component: () => import('@/views/syst/ref/idit/searchIdit.vue')
  },
  {
    path: '/syst/ref/idit/onIdit/:idit_encrid',
    name: 'Layout items types maintanance',
    props: true,
    component: () => import('@/views/syst/ref/idit/onIdit.vue')
  },
  {
    path: '/syst/ref/neig/searchNeig',
    name: 'Search accommodation properties',
    component: () => import('@/views/syst/ref/neig/searchNeig.vue')
  },
  {
    path: '/syst/ref/neig/onNeig/:neig_encrid',
    name: 'Accommodation property maintanance',
    props: true,
    component: () => import('@/views/syst/ref/neig/onNeig.vue')
  },
  {
    path: '/syst/ref/errs/searchErrs',
    name: 'Search accommodation errors',
    component: () => import('@/views/syst/ref/errs/searchErrs.vue')
  },
  {
    path: '/syst/ref/errs/onErrs/:errs_encrid',
    name: 'Accommodation error maintanance',
    props: true,
    component: () => import('@/views/syst/ref/errs/onErrs.vue')
  },
  {
    path: '/syst/ref/indi/searchIndi',
    name: 'Search Layout items',
    component: () => import('@/views/syst/ref/indi/searchIndi.vue')
  },
  {
    path: '/syst/ref/indi/onIndi/:indi_encrid',
    name: 'Layout items maintanance',
    props: true,
    component: () => import('@/views/syst/ref/indi/onIndi.vue')
  },
  {
    path: '/syst/ref/indd/searchIndd',
    name: 'Search Layout details',
    component: () => import('@/views/syst/ref/indd/searchIndd.vue')
  },
  {
    path: '/syst/ref/indd/onIndd/:indd_encrid',
    name: 'Layout details maintanance',
    props: true,
    component: () => import('@/views/syst/ref/indd/onIndd.vue')
  },
  {
    path: '/syst/ref/valu/searchValu',
    name: 'Currencies',
    component: () => import('@/views/syst/ref/valu/searchValu.vue')
  },
  {
    path: '/syst/ref/plts/searchPlts',
    name: 'Cities',
    component: () => import('@/views/syst/ref/plts/searchPlts.vue')
  },
  {
    path: '/syst/ref/gebr/searchGebr',
    name: 'ARES users',
    component: () => import('@/views/syst/ref/gebr/searchGebr.vue')
  },
  {
    path: '/syst/ref/arrq/searchArrq',
    name: 'ARES requests',
    component: () => import('@/views/syst/ref/arrq/searchArrq.vue')
  },
  {
    path: '/syst/ref/dashboard/dashBoard',
    name: 'Dashboard2',
    component: () => import('@/views/syst/dashboard/dashBoard.vue')
  },  
  {
    path: '/syst/ref/dashboard/dashBoardDev',
    name: 'Dashboard (DEV)',
    component: () => import('@/views/syst/dashboard/dashBoardDev.vue')
  },    
  {
    path: '/syst/ref/aftercare/aftercareDashboard',
    name: 'Dashboard (Aftercare)',
    component: () => import('@/views/syst/dashboard/dashboardAftercare.vue')
  },      
  {
    path: '/syst/ref/valu/onValu/:valu_encrid',
    name: 'Currency maintanance',
    props: true,
    component: () => import('@/views/syst/ref/valu/onValu.vue')
  },
  {
    path: '/syst/ref/plts/onPlts/:plts_encrid',
    name: 'City maintanance',
    props: true,
    component: () => import('@/views/syst/ref/plts/onPlts.vue')
  },
  {
    path: '/syst/ref/gebr/onGebr/:gebr_encrid',
    name: 'ARES users maintanance',
    props: true,
    component: () => import('@/views/syst/ref/gebr/onGebr.vue')
  },
  {
    path: '/syst/ref/arrq/onArrq/:arrq_encrid',
    name: 'ARES request maintanance',
    props: true,
    component: () => import('@/views/syst/ref/arrq/onArrq.vue')
  },
  {
    path: '/syst/ref/akcd/searchAkcd',
    name: 'Discount codes',
    component: () => import('@/views/syst/ref/akcd/searchAkcd.vue')
  },
  {
    path: '/syst/ref/akcd/akcd_ref_overview',
    name: 'Discount codes nw',
    component: () => import('@/views/syst/ref/akcd/akcd_ref_overview.vue')
  },
  {
    path: '/syst/ref/klav/searchKlav',
    name: 'Guest cancellation terms',
    component: () => import('@/views/syst/ref/klav/searchKlav.vue')
  },
  {
    path: '/syst/ref/klav/onKlav/:klav_encrid',
    name: 'Guest cancellation terms maintanance',
    props: true,
    component: () => import('@/views/syst/ref/klav/onKlav.vue')
  },
  {
    path: '/syst/ref/hsav/searchHsav',
    name: 'Accommodation cancellation terms',
    component: () => import('@/views/syst/ref/hsav/searchHsav.vue')
  },
  {
    path: '/syst/ref/hsav/onHsav/:hsav_encrid',
    name: 'Accommodation cancellation terms maintanance',
    props: true,
    component: () => import('@/views/syst/ref/hsav/onHsav.vue')
  },
  {
    path: '/mail/showMail/:mail_encrid',
    name: 'Show mail',
    props: true,
    component: () => import('@/views/mail/showMail.vue')
  },
  {
    path: '/eign/hostProfile/:eign_encrid',
    name: 'Host profile',
    props: true,
    component: () => import('@/views/eign/hostProfile.vue')
  },
  {
    path: '/whap/showWhap/:whap_encrid',
    name: 'Show Whatsapp',
    props: true,
    component: () => import('@/views/whap/showWhap.vue')
  },  
  {
    path: '/task/customer_success/lgcd/onLgcd',
    name: 'Lgcd',
    props: true,
    component: () => import('@/views/task/customer_success/lgcd/onLgcd.vue')
  },    
  {
    path: '/mail/showMailByNumber',
    name: 'Show mail by Number',
    component: () => import('@/views/mail/showMailByNumber.vue')
  },  
  {
    path: '/syst/openai/mnOpenai',
    name: 'Open ai test ground new conversation',
    props: true,
    component: () => import('@/views/syst/openai/testOpenai.vue')
  },
  {
    path: '/syst/openai/mnOpenai/:conversation_id',
    name: 'Open ai test ground',
    props: true,
    component: () => import('@/views/syst/openai/testOpenai.vue')
  },
  {
    path: '/syst/openai/faqWebsite',
    name: 'Open ai website faq',
    component: () => import('@/views/syst/openai/faqWebsite.vue')
  },
  {
    path: '/syst/openai/faqAccommodation',
    name: 'Open ai accommodation faq',
    component: () => import('@/views/syst/openai/faqAccommodation.vue')
  },
  {
    path: '/syst/openai/detailAccommodation',
    name: 'Open ai accommodation detail',
    component: () => import('@/views/syst/openai/detailAccommodation.vue')
  },
  {
    path: '/syst/openai/vectorstores',
    name: 'Open ai vectorstores detail',
    component: () => import('@/views/syst/openai/vectorStores.vue')
  },
  {
    path: '/syst/openai/assistants',
    name: 'Open ai assistants detail',
    component: () => import('@/views/syst/openai/virtualAssistants.vue')
  },
  {
    path: '/syst/openai/conversations',
    name: 'Open ai conversations detail',
    component: () => import('@/views/syst/openai/virtualConversations.vue')
  },
  {
    path: '/syst/openai/conversationDetails/:id',
    name: 'Open ai conversation details',
    props: true,
    component: () => import('@/views/syst/openai/virtualConversationDetails.vue')
  },
  {
    path: '/syst/openai/conversationRuns/:thread_id/:run_id',
    name: 'Open ai conversation run details',
    props: true,
    component: () => import('@/views/syst/openai/virtualConversationRuns.vue')
  },
  {
    path: '/syst/openai/management',
    name: 'Open ai management',
    component: () => import('@/views/syst/openai/openaiManagement.vue')
  },
  {
    path: '/syst/messages/testMessages',
    name: 'test Messages',
    props: true,
    component: () => import('@/views/syst/messages/testMessages.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

export default router
